var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-provider',{attrs:{"request":_vm.amazonEndpoint,"immediate":true},on:{"success":_vm.handleAmazonRequestSuccess,"error":_vm.handleAmazonRequestError}},[_c('mega-menu-dropdown',{attrs:{"items":_vm.accountsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }